import { canv } from "@/canv/global";
import type { CommentMessage, CommentMessageRemove } from "@/elements/comment/types";
import type { ArrowData } from "@/group/types";
import type { FixType } from "@/shared/types/fixType";
import type {
    CreateOrDeleteParticipantProperty,
    CreateOrDeleteVoteProperty,
    PropertyBuildEventAction,
    PropertyBuildEventStructure,
} from "./types";

export class PropertyBuildEvent {
    event: PropertyBuildEventStructure;

    constructor(
        UID: string,
        fixType: FixType,
        action: PropertyBuildEventAction,
        property:
            | ArrowData
            | CommentMessage
            | CommentMessageRemove
            | CreateOrDeleteVoteProperty
            | CreateOrDeleteParticipantProperty,
    ) {
        this.event = {
            type: "propertyBuild",
            action,
            UID,
            fixType,
            property,
        };
    }

    execEvent() {
        const entity = canv.canvasController.FindByUID(this.event.UID);

        if (entity === null) {
            return;
        }

        //Убрать после иной типизации FindByUID
        //@ts-ignore
        entity.buildProperty(this.event.property, this.event.fixType, this.event.action);
    }

    checkEvent() {
        const entity = canv.canvasController.FindByUID(this.event.UID);

        if (entity == null) {
            return false;
        }

        return true;
    }

    getEvent() {
        return this.event;
    }

    loadEvent(event: PropertyBuildEventStructure) {
        this.event = event;
    }

    getTwin() {
        const action: PropertyBuildEventAction = this.event.action === "add" ? "remove" : "add";

        // тут возможно стоит заново искать стрелку (property) с нужным ключом, просто это очень узкий кейс
        const twin = new PropertyBuildEvent(
            this.event.UID,
            this.event.fixType,
            action,
            this.event.property,
        );

        return twin;
    }
}
